import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CallState {
  isConnected: boolean;
  isConnecting: boolean;
  isCallModalOpen: boolean;
  isMinimized: boolean;
  ultravoxStatus: string;
  agentName: string;
  agentId: string;
  agentKey: string;
  botTranscript: any;
  userTranscript: any;
}

const initialState: CallState = {
  isConnected: false,
  isConnecting: false,
  isCallModalOpen: false,
  isMinimized: false,
  ultravoxStatus: 'disconnected',
  agentName: '',
  agentId: '',
  agentKey: '',
  botTranscript: {},
  userTranscript: {},
};

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    startCall: (
      state,
      action: PayloadAction<{
        agentId: string;
        agentKey: string;
        agentName: string;
      }>
    ) => {
      state.isCallModalOpen = true;
      state.isConnecting = true;
      state.agentId = action.payload.agentId;
      state.agentKey = action.payload.agentKey;
      state.agentName = action.payload.agentName;
      state.ultravoxStatus = 'connecting';
      state.isMinimized = false;
    },
    setCallStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    setConnecting: (state, action: PayloadAction<boolean>) => {
      state.isConnecting = action.payload;
    },
    setUltravoxStatus: (state, action: PayloadAction<string>) => {
      state.ultravoxStatus = action.payload;
    },
    setCallModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCallModalOpen = action.payload;
    },
    setMinimized: (state, action: PayloadAction<boolean>) => {
      state.isMinimized = action.payload;
    },
    setBotTranscript: (state, action: PayloadAction<any>) => {
      state.botTranscript = action.payload;
    },
    setUserTranscript: (state, action: PayloadAction<any>) => {
      state.userTranscript = action.payload;
    },
    endCall: state => {
      state.isConnected = false;
      state.isConnecting = false;
      state.isCallModalOpen = false;
      state.isMinimized = false;
      state.ultravoxStatus = 'disconnected';
      state.agentName = '';
      state.agentId = '';
      state.agentKey = '';
    },
    resetCallState: state => {
      state.isConnected = false;
      state.isConnecting = false;
      state.isCallModalOpen = false;
      state.isMinimized = false;
      state.ultravoxStatus = 'disconnected';
      state.agentName = '';
      state.agentId = '';
      state.agentKey = '';
      state.botTranscript = {};
      state.userTranscript = {};
    },
  },
});

export const {
  startCall,
  setCallStatus,
  setConnecting,
  setUltravoxStatus,
  setCallModalOpen,
  setMinimized,
  setBotTranscript,
  setUserTranscript,
  endCall,
  resetCallState,
} = callSlice.actions;
export default callSlice.reducer;
